import { AdditionalServicesFragment, GdsServiceRestrictionType } from '@websky/graphql';
import { GdsServicesCalculatedLimitInfo, GdsServicesLimitInfo, KeyByRestriction } from '../../../../types';

const keyByRestrictionType: {
	[key in GdsServiceRestrictionType]: KeyByRestriction;
} = {
	[GdsServiceRestrictionType.byRfiscPerOrder]: 'rfisc',
	[GdsServiceRestrictionType.byRfiscPerSegment]: 'rfisc',
	[GdsServiceRestrictionType.byTypePerOrder]: 'type',
	[GdsServiceRestrictionType.byTypePerSegment]: 'type',
	[GdsServiceRestrictionType.bySubTypePerOrder]: 'subType',
	[GdsServiceRestrictionType.bySubTypePerSegment]: 'subType'
};

export function getGdsServicesCalculatedCountInfoSelector(
	passengerIds: string[],
	segmentIds: string[],
	gdsServicesRestrictions: AdditionalServicesFragment['gdsServices']['servicesRestrictionsByType'],
	selectedServicesByType: GdsServicesLimitInfo
): GdsServicesCalculatedLimitInfo {
	const result: GdsServicesCalculatedLimitInfo = {};

	for (const passengerId of passengerIds) {
		if (!result[passengerId]) {
			result[passengerId] = {};
		}

		const passengerSelected = selectedServicesByType[passengerId];

		for (const segmentId of segmentIds) {
			if (!result[passengerId][segmentId]) {
				result[passengerId][segmentId] = { rfisc: {}, type: {}, subType: {} };
			}

			gdsServicesRestrictions.forEach(restriction => {
				const restrictionType = restriction.restrictionType;
				const restrictionMaxCount = restriction.maxCount;

				const key = keyByRestrictionType[restrictionType];

				const isRestrictionPerOrder =
					restrictionType === GdsServiceRestrictionType.byRfiscPerOrder ||
					restrictionType === GdsServiceRestrictionType.byTypePerOrder ||
					restrictionType === GdsServiceRestrictionType.bySubTypePerOrder;

				const restrictionPerType = isRestrictionPerOrder ? 'order' : 'segment';

				const selectedTotalCount = restriction.value.reduce(
					(count, value) =>
						count +
						(isRestrictionPerOrder
							? passengerSelected?.total?.[key]?.[value] ?? 0
							: passengerSelected?.segments?.[segmentId]?.[key]?.[value] ?? 0),
					0
				);

				restriction.value.forEach(value => {
					result[passengerId][segmentId][key][value] = {
						maxCount: restrictionMaxCount,
						selectedCount: selectedTotalCount,
						diffCount: restrictionMaxCount - selectedTotalCount,
						restrictionValue: restriction.value,
						restrictionType,
						restrictionPerType,
						key
					};
				});
			});
		}
	}

	return result;
}
